import React, { FC, useEffect } from 'react';
import { Button, Space } from 'antd';
import { useDispatch } from 'react-redux';

import { buttonActionText } from '../utils/options';
import { useCreateDisputeAIMutation } from '../service/attributes';
import { setAIRecommends } from '../store/attributesSlice';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

interface AttributesActionProps {
    loading: boolean;
    isBlocked: boolean;
}

export const AttributesAction: FC<AttributesActionProps> = ({
    loading,
    isBlocked,
}) => {
    const { id } = useAppSelector(selectShopCurrent);
    const dispatch = useDispatch();

    const [createDisputeAI, { isSuccess }] = useCreateDisputeAIMutation();

    const disputeAI = () => {
        const payload = {
            shop_id: Number(id),
        };

        createDisputeAI(payload);
    };

    useEffect(() => {
        if (isSuccess) {
            dispatch(setAIRecommends(true));
        }
    }, [isSuccess]);

    return (
        <Space>
            <Button
                loading={loading}
                disabled={loading || isBlocked}
                type={'primary'}
                onClick={disputeAI}
            >
                {buttonActionText}
            </Button>
        </Space>
    );
};
